import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.footer`
  grid-area: footer;
  text-align: center;

  padding-top: 20px;
  padding-bottom: 20px;
  background: rgba(0,0,0,0);
  color: black;

  @media (min-width: 768px) {
    justify-content: space-between;
    text-align: left;
  }
`;

const Terms = styled.div`
  font-size: 0.75rem;
`;

const Footer = () => {
  return (
    <Wrapper className="container-fluid">
      <Terms className="mb-2 mb-md-0 text-center">
        *Prices listed are the average cost for treatment. Actual price is based on custom treatments plans. Prices subject to change.
      </Terms>
      <Terms className="text-center">
        *Terms and Conditions Apply. Your interest rate will depend upon credit score, income, loan amount, loan term, and credit history.
      </Terms>
    </Wrapper>
  );
};

export default Footer;
